import toDate from 'date-fns/toDate';
import parseISO from 'date-fns/parseISO';

/** @deprecated копия libs/skypro/misc/src/utils/string-to-date-transfrom.ts для разрыва циркулярки */
export const transformTimeWithoutTimezone = (value: string): Date => {
  const timezoneRegexp = /(?:Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])$/;
  const dateWithoutTimezone = value.replace(timezoneRegexp, '');

  return toDate(parseISO(dateWithoutTimezone));
};
